<template>
	<v-dialog persistent @click:outside="closeDialog()" :value="dialog" max-width="450" >
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.chat.attachment.delete') }}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				{{ $vuetify.lang.t('$vuetify.views.chat.attachment.confirmDelete') }}<br>
			</v-card-text>
			<v-card-actions class="py-3">
				<v-btn @click="closeDialog()" class="ml-auto"> {{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn @click="submit()" :loading="saving" color="primary"> <v-icon >mdi-check</v-icon> {{ $vuetify.lang.t('$vuetify.delete') }} </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialog: false,
			saving: false,
			message: null,
			attachment: null
		}
	},

	methods: {
		closeDialog() {
			this.message = null;
			this.attachment = null;
			this.dialog = false;
			this.$emit('close');
		},
		async submit() {
			this.saving = true;
			let res = await this.$store.dispatch('files/deleteFile', {id: this.attachment.id});
			if(res.success) {
				this.$store.commit('chat/removeAttachment', {
					attachment: this.attachment,
					message: this.message
				});

				this.$snackbar.success("Pomyślnie usunięto plik");
				this.$emit('deleted', this.message);
				this.closeDialog();
			}
			this.saving = false;
		},
		showDialog(attachment, message) {
			this.attachment = attachment;
			this.message = message;
			this.dialog = true;
		}
	}
}
</script>
